export default new class PopupsMobile {
    constructor() {
        this.popupsWrapper = '[data-popups-mobile-wrapper]';

        if (!$(this.popupsWrapper).length) return;

        this.btnOpen = '[data-popup-mobile-open]';
        this.btnClose = '[data-popup-mobile-close]';
        this.popup = '[data-popup-mobile]';
        this.popupPayPal = '[data-popup-mobile-paypal]';
        this.popupCash = '[data-popup-mobile-cash]';

        this.classOpen = '_open';
        this.classNoScroll = 'fs--no-scroll';

        this.eventsHandler()
    }

    eventsHandler() {
        let $doc = $(document);

        $doc.on('click', this.btnOpen, (e) => {
            this.openPopup($(e.currentTarget))
        });

        $doc.on('click', this.btnClose, (e) => {
            this.closePopup($(e.currentTarget))
        })
    }


    openPopup($btn) {
        let dataVal = 'popup-mobile-open';

        if ($btn.is('[data-valid-form]')) dataVal = 'valid-form';

        let popupData = $btn.data(dataVal),
            arPopups = $(this.popup);

        // find needed popup
        let popup = arPopups.map((i, item) => {
           if ($(item).data('popup-mobile') === popupData){
               return item;
           }
        });

        $(popup).addClass(this.classOpen);
        $(this.popupsWrapper).addClass(this.classOpen);
        $('body').addClass(this.classNoScroll)
    }

    openOrderPopup($btn, data) {
        let popupName = $btn.data('valid-form'),
            $popup = $(`[data-popup-mobile=${popupName}]`),
            popupTemplate = null;

        switch (data.payment) {
            case 'yandex': popupTemplate = this.getYandexPaymentTemplate(data); break;
            case 'paypal': $(this.popupPayPal).addClass('_show'); this.initPayPal(data); break;
            default:  $(this.popupCash).addClass('_show');
        }

        if (popupTemplate) $popup.append(popupTemplate);

        $popup.addClass(this.classOpen);
        $(this.popupsWrapper).addClass(this.classOpen);
        $('body').addClass(this.classNoScroll);
    }

    getYandexPaymentTemplate(data) {
        let src = `https://money.yandex.ru/quickpay/shop-widget?writer=seller&targets=${data.order}&targets-hint=&default-sum=${data.price}&button-text=11&payment-type-choice=on&hint=&successURL=http%3A%2F%2Ffashiong.local&quickpay=shop&account=410015836347424`;

        return (
            `<div class="popup-mobile__title">Ваш заказ успешно принят! <br> Вы можете оплатить его с помощью Яндекс.Деньги</div>
            <iframe src="${src}" width="100%" height="222" frameborder="0" allowtransparency="true" scrolling="no"></iframe>`
        )
    }

    initPayPal(ajaxData) {
        paypal.Button.render({

            // Set your environment

            env: 'sandbox', // sandbox | production

            // Specify the style of the button

            style: {
                label: 'checkout',
                size: 'medium',    // small | medium | large | responsive
                shape: 'pill',     // pill | rect
                color: 'gold'      // gold | blue | silver | black
            },

            // PayPal Client IDs - replace with your own
            // Create a PayPal app: https://developer.paypal.com/developer/applications/create

            client: {
                sandbox: 'AU3YjBzg5JHD2s3-E7febJJJryg6Z0e0wzuNkVvns5cpdfem7NybMUW8moQ1eOqgkDGr0ih1l0iWHXp3',
                production: ''
            },

            payment: function (data, actions) {
                return actions.payment.create({
                    payment: {
                        transactions: [
                            {
                                amount: {total: ajaxData.price, currency: 'EUR'},
                                custom: ajaxData.order,
                            }
                        ]
                    }
                });
            },

            onAuthorize: function (data, actions) {
                return actions.payment.execute().then(function () {
                    window.alert('Оплачено!');
                });
            }

        }, '#paypal-button-container-mobile');
    }

    closePopup($btn) {
        if (!$btn) {
            $btn = $(`._open ${this.popup}`).find(this.btnClose);
        }

        let $popupsWrap = $btn.closest(this.popupsWrapper),
            $popup = $btn.closest(this.popup);

        $popupsWrap.removeClass(this.classOpen);
        $popup.removeClass(this.classOpen);
        $('body').removeClass(this.classNoScroll);

        if ($popup.data('popup-mobile') === 'success-order') {
            window.location = '/catalog';
        }
    }
}
